"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIKABY_ID = exports.AutoTestID = exports.HomeId = exports.ADDRESS_ID = exports.FOLDER_SHOWCASE_ID = exports.TEMPLATE_CENTER_ID = exports.NOTIFICATION_ID = exports.NAV_ID = exports.DATASHEET_ID = exports.WORKBENCH_SIDE_ID = void 0;
const WORKBENCH_SIDE_ID = __importStar(require("./workbench_side_id"));
exports.WORKBENCH_SIDE_ID = WORKBENCH_SIDE_ID;
const DATASHEET_ID = __importStar(require("./datasheet_id"));
exports.DATASHEET_ID = DATASHEET_ID;
const NAV_ID = __importStar(require("./nav_id"));
exports.NAV_ID = NAV_ID;
const NOTIFICATION_ID = __importStar(require("./notification_id"));
exports.NOTIFICATION_ID = NOTIFICATION_ID;
const TEMPLATE_CENTER_ID = __importStar(require("./template_center_id"));
exports.TEMPLATE_CENTER_ID = TEMPLATE_CENTER_ID;
const FOLDER_SHOWCASE_ID = __importStar(require("./folder_showcase_id"));
exports.FOLDER_SHOWCASE_ID = FOLDER_SHOWCASE_ID;
const ADDRESS_ID = __importStar(require("./address_id"));
exports.ADDRESS_ID = ADDRESS_ID;
const HomeId = __importStar(require("./home_id"));
exports.HomeId = HomeId;
const AutoTestID = __importStar(require("./auto_test_id"));
exports.AutoTestID = AutoTestID;
const VIKABY_ID = __importStar(require("./vikaby"));
exports.VIKABY_ID = VIKABY_ID;
//# sourceMappingURL=index.js.map